import Vue from 'vue';
import Vuex from 'vuex';
import Language from '../enums/Language';

Vue.use(Vuex)

let savedLanguage = localStorage.getItem('language');
savedLanguage = savedLanguage ? JSON.parse(savedLanguage) : undefined;

export default new Vuex.Store({
  state: {
    language: savedLanguage || Language.PORTUGUESE,
    event: undefined,
    options: [],
    siteUnderMaintenance: false,

  },
  getters: {
    eventHasOption: (state) => (option) => {
      return state.options.some(opt => opt.option.resource === option.name);
    }
  },
  mutations: {
    language: (state, language) => state.language = language,
    event: (state, event) => state.event = event,
    options: (state, options) => state.options = options,
    siteUnderMaintenance: (state, status) => (state.siteUnderMaintenance = status),
  },
  actions: {
    language({commit}, language){
      if (language) localStorage.setItem('language', JSON.stringify(language));
      else localStorage.removeItem('language');
      commit('language', language);
    },
    updateMaintenanceStatus({ commit }, status) {
      commit("siteUnderMaintenance", status);
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js